module.exports = __webpack_public_path__ + "static/media/gallery-16.8406290b.jpg";